<template>
  <div class="userInfo">
    <div class="changeAvatar">
      <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
      <el-upload
        class="avatar-uploader"
        :action="action"
        :show-file-list="false"
        :on-success="handleAvatarSuccess">
        <!-- <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar"> -->
        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
        <span  class="avatarTit">更换头像</span>
      </el-upload>
    </div>
    <div class="userNameBox userBlock">
      <label class="labelTitle">昵称：</label>
      <el-input v-model="userInfo.nickname" placeholder="请输入内容" style="width: 220px"></el-input>
			<a @click.prevent="updatePwd" class="updatePwd">修改密码</a>
    </div>
    <div class="userNameBox userBlock">
      <label class="labelTitle">性别：</label>
      <el-radio v-model="userInfo.sex" label="男">男</el-radio>
      <el-radio v-model="userInfo.sex" label="女">女</el-radio>
    </div>
    <div class="birthTimeBox userBlock">
      <label class="labelTitle">出生日期：</label>
      <el-date-picker
        v-model="userInfo.birthday"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd">
      </el-date-picker>
    </div>
    <div class="bindPhoneBox userBlock">
      <label class="labelTitle">绑定手机号：</label>
      <div class="phoneInfo">
        <span>{{ userInfo.phone }}</span>
        <span @click="$router.push('/changePhone')">更换</span>
      </div>
    </div>
    <div class="userInfoSave" @click="saveUserInfo" v-throttle>保存</div>
	<el-dialog
	  title="修改密码"
	  :visible.sync="updatePwdDialog"
	  width="30%"
	  :before-close="handleClose">
		<el-form :model="forgetPwdForm" :rules="forgetPwdRules" ref="forgetPwdRef" label-width="100px" class="">
			<el-tabs v-model="forgetPwdForm.passwordType" type="border-card">
		    <el-tab-pane label="旧密码修改" name="0">
					<el-form-item label="旧密码" prop="oldPassword">
					  <el-input v-model="forgetPwdForm.oldPassword" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword">
					  <el-input v-model="forgetPwdForm.newPassword" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="confirmPassword">
					  <el-input v-model="forgetPwdForm.confirmPassword" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
				</el-tab-pane>
		    <el-tab-pane label="验证码修改" name="1">
					<el-form-item label="手机号码">
					  <el-input v-model="userPhone" disabled></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword">
					  <el-input v-model="forgetPwdForm.newPassword" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="confirmPassword">
					  <el-input v-model="forgetPwdForm.confirmPassword" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="verificationCode" style="position: relative;">
					  <el-input v-model="forgetPwdForm.verificationCode" placeholder="请输入验证码" maxlength="6"></el-input>
					  <span v-show="codeShow" class="forgetCodeBtn" @click="getCode(true)">获取验证码</span>
					  <span v-show="!codeShow" class="forgetCodeBtn codeCount">重新获取({{ codeCountNum }}s)</span>
					</el-form-item>
				</el-tab-pane>
		  </el-tabs>
	   </el-form>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="updatePwdDialog = false">取 消</el-button>
	    <el-button type="primary" @click="confirmUpdatePwd">确 定</el-button>
	  </span>
	</el-dialog>
  </div>

</template>

<script>
import imagesUrl from '../../../assets/imagesUrl'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import {mapGetters, mapMutations} from 'vuex'
import md5 from 'js-md5';
let validatePhone = (rule,value,callback) => {
	let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
	if(!reg.test(value)) return callback('手机号码格式不正确')
	callback()
}

export default {
  mixins: [listSearchMixin],
  name: 'userInfo',
  data () {
    return {
      headUrl: imagesUrl.avatar,
      userName: 'Curmudgeons',
      gender: '1',
      birthTime: '',
      userInfoData: {},
      avatarImg: '',
      action: api.upload,
	  codeCountNum: '',
	  codeShow: true,
	  timer: null,
	  updatePwdDialog: false,
	  forgetPwdForm: {
	  		  verificationCode: '',
	  		  newPassword: '',
	  		  oldPassword: '',
			  confirmPassword: '',
	  		  passwordType: 0
	  },
	  forgetPwdRules: {
	  		  newPassword: [
	  			  { required: true, message: '请输入新密码', trigger: 'blur' },
	  			  { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
	  		  ],
	  		  oldPassword: [
	  			  { required: true, message: '请输入旧密码', trigger: 'blur' },
	  			  { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
	  		  ],
	  		  verificationCode: [
	  			  { required: true, message: '请输入验证码', trigger: 'blur' }
	  		  ],
	  		  confirmPassword: [
	  			  { required: true, message: '请输入旧密码', trigger: 'blur' }
	  		  ]
	  },
	  userPhone: ''
    }
  },
  mounted () {
    // this.getUserInfo()
	this.userPhone = `${this.userInfo.phone.slice(0,3)}****${this.userInfo.phone.slice(7,12)}`
  },
  computed: {
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO', // 修改用户信息
      setAVATR: 'SET_AVATAR', // 修改用户信息
	  updateUserAvatar: 'updateUserAvatar'
    }),
	//关闭dialog
	handleClose(){
		this.updatePwdDialog = false
		this.$refs.forgetPwdRef.resetFields()
	},
	//确定修改密码
	confirmUpdatePwd(){
		// let mm = md5(this.forgetPwdForm.password)
		if(this.forgetPwdForm.passwordType == 0){
			this.forgetPwdRules.verificationCode[0].required = false
			this.forgetPwdRules.oldPassword[0].required = true
		}else {
			this.forgetPwdRules.verificationCode[0].required = true
			this.forgetPwdRules.oldPassword[0].required = false
		}
		this.$refs.forgetPwdRef.validate(valid => {
			if(!valid) return

			if(this.forgetPwdForm.newPassword != this.forgetPwdForm.confirmPassword) return this.$message.warning('密码不一致')
			let params = {
			  url: api.updatePass,
			  method: "post",
			  data: {
				verificationCode: this.forgetPwdForm.verificationCode,
				oldPassword: md5(this.forgetPwdForm.oldPassword),
				newPassword: md5(this.forgetPwdForm.newPassword),
				confirmPassword: md5(this.forgetPwdForm.confirmPassword),
				passwordType: +this.forgetPwdForm.passwordType,
			  },
			}
			this.sendReq(params,(res)=> {
				if(res.status == 200){
					this.$message.success('修改密码成功!')
					this.updatePwdDialog = false
				}else{
					this.$message.error(res.msg)
				}
			})
		})
	},
	//修改密码
	updatePwd(){
		this.updatePwdDialog = true
	},
    getUserInfo () {
      let self = this
      let params = {
        url: api.getUser,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.setUserInfo(res.data)
        }
      })
    },
	getCode() {
	  const TIME_COUNT = 60;
	  let self = this;
	  let reg = /^1[13456789]\d{9}$/;
	  if (!this.userInfo.phone) {
	    self.$message.error("手机号为空");
	    return;
	  }
	  let code="login";
	  // if(self.isRegistered === "2" && this.loginactive == 1){
	  //       code="login"
	  // }else{
	  //    code="register"
	  // }
	  let params = {
	    url: api.vCode ,
	    method: "POST",
	    data: {
	      phone: this.userInfo.phone,
	      type:code
	    },
	  };
	  self.sendReq(params, (res) => {
	      if (res.status === 200) {
	        if (!this.timer) {
	          this.codeCountNum = TIME_COUNT;
	          this.codeShow = false;
	          this.timer = setInterval(() => {
	            if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
	              this.codeCountNum--;
	            } else {
	              this.codeShow = true;
	              clearInterval(this.timer);
	              this.timer = null;
	            }
	          }, 1000);
	        }
	        this.$message({
	          message: "验证码获取成功",
	          type: "success",
	        });
	      } else {
	        this.$message({
	          message: res.msg,
	          type: "error",
	        });
	      }
	    });
	  },
    saveUserInfo () {
      let self = this
      let params = {
        url: api.update,
        method: 'post',
        data: {
          nickname: self.userInfo.nickname,
          sex: self.userInfo.sex,
          birthday: self.userInfo.birthday,
          avatar: self.userInfo.avatar
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: '修改成功！',
            type: 'success'
          })
          this.getUserInfo()
        }
      })
    },
    // 上传头像
    handleAvatarSuccess (res) {
		this.updateUserAvatar(res.link)
      // this.userInfo.avatar =res.link;
      //this.setAVATR(res)
      //this.saveUserInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.labelTitle {
  width: 100px;
  text-align: right;
}
.updatePwd {
  margin-left: 10px;
  color: #ff7800;
  text-decoration: underline;
}
.forgetCodeBtn {
  padding: 0 10px;
  background: #eeeeee;
  border-radius: 4px;
  font-size: 12px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
.userInfo {
  padding: 30px;
  border: 1px solid #E5E5E5;
  .changeAvatar {
    width: 134px;
    height: 134px;
    padding-left: 50px;
    position: relative;
		overflow: hidden;
    .avatar {
      width: 100%;
    }
    .avatarTit {
      height: 30px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
      font-size: 16px;
      background: rgba(84, 84, 84, 0.5);
      width: 100%;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .userNameBox {
    >>> .el-input {
      width: 180px;
    }
  }
  .userBlock {
    margin-top: 30px;
    display: flex;
    align-items: center;
    label {
      font-weight: normal;
      font-size: 16px;
      color: #666666;
    }
  }
  .bindPhoneBox {
    .phoneInfo {
      font-size: 16px;
      span {
        margin-right: 15px;
        text-decoration: underline;
        cursor: pointer;
      }
      span:nth-child(1) {
        color: #333333;
        text-decoration: none;
        cursor: default;
      }
      span:nth-child(2) {
        color: $mainColor;
      }
      span:nth-child(3) {
        color: #666666;
      }
    }
  }
  .userInfoSave {
    margin: 50px 0 0 80px;
    width: 115px;
    height: 30px;
    line-height: 30px;
    background: #FFFFFF;
    border: 1px solid $mainColor;
    border-radius: 4px;
    text-align: center;
    color: $mainColor;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userInfo/userInfo.vue